export default class LiveChatMessageForm {
  public content: string = ''
  public targetableId: number
  public targetableType: string = ''
  public attachmentIds: number[] = []
}
